(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-product-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tt-product-video')) {
    customElements.define('tt-product-video', class extends HTMLElement {
      connectedCallback() {
        this.listeners?.abort();
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        this.dialog = this.querySelector('dialog');
        this.video = this.querySelector('video');
        this.opener = this.querySelector('[data-video-open]');
        const closeButton = this.querySelector('[data-video-close]');
        if (!this.dialog || !this.video || !this.opener || !closeButton) return;

        this.opener.addEventListener('click', () => {
          if (this.dialog.open) return;
          this.dialog.showModal();
          const playback = this.video.play();
          playback?.catch(() => {});
        }, options);

        closeButton.addEventListener('click', () => this.closeVideo(), options);
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeVideo();
        }, options);

        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
            this.closeVideo();
          }
        }, options);

        this.dialog.addEventListener('close', () => {
          this.stopVideo();
          if (this.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
      }

      stopVideo() {
        if (!this.video) return;
        this.video.pause();
        if (this.video.readyState > 0) this.video.currentTime = 0;
      }

      closeVideo() {
        this.stopVideo();
        if (this.dialog?.open) this.dialog.close();
      }

      disconnectedCallback() {
        this.listeners?.abort();
        this.closeVideo();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
